import { useEffect, useState, useCallback , useRef } from 'react';
import { Api } from '../../../componentes/Api';
import { Card, Col, Row, CardBody, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter } from "reactstrap"
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';

import moment from "moment";
import Select from 'react-select';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './FT.css';

let emp = 0;
const modeloDatos = {
    pacienteID: 0,
    empresaID: 0,
    nombres: '',
    apellidos: '',
    cedula: '',
    telefono: '',
    celular: '',
    fechaNacimiento: new Date(),
    sexo: '',
    tipoOrden: 0,
    seguroID: 0,
    nombreSeguro: '',
    poliza: '',
    centroID: 0,
    diagnostico: '',
    diagnosticoClinico: '',
    direccion: '',
    resultado: '',
    tratamientoID: 0,
    nombreTratamiento: '',
    toxicos: '',
    creadoPor: '',
    fechaCreado:  new Date(),
    modificadoPor: '',
    fechaModificado: new Date(),
    imagen: '',
    alergicos: '',
    antecedentesMedicos: '',
    examenFisico: '',
    antecedentesFamiliares: '',
    habitosAlimenticios: '',
    antecedentesMedicamentos: '',
    nube: 0,
    tierra: 0,
    codigoUnico: '',
    ocupacion: '',
    email: '',
    estadoCivil: '',
    referidoPor: '',
    opitalizado: 0,
    d_pitalizacion: '',
    tomaMedicamento: 0,
    es_Alergico: 0,
    ha_Cirugia: 0,
    transfusion: 0,
    fuma: 0,
    vece_Fuma: 0,
    radiaciones: 0,
    porque_Radiaciones: '',
    asma: 0,
    diabetes: 0,
    epilepsia: 0,
    vih: 0,
    artritis: 0,
    hepatitis: 0,
    tuberculosis: 0,
    hipertension: 0,
    ulceras: 0,
    fiebre: 0,
    ansiedad: 0,
    desorden: 0,
    enfermedades_V: 0,
    enfermedades_L: 0,
    renales: 0,
    enfermedades_C: 0,
    cambio_Salud: 0,
    embarazada: 0,
    observaciones: ''
};
const modeloRecord = {
    recordPacienteID: 0,
    empresaID: emp,
    pacienteID: 0,
    historiaClinica: '',
    comentario: '',
    fecha: new Date,
    codigoUnico: ''
}
const modeloReceta = {
    recetaID: 0,
    empresaID: emp,
    pacienteID: 0,
    recordPacienteID: 0,
    medicamentoID: 0,
    nombreMedicamento: '',
    fecha: new Date,
    comentario: '',
    fechaCreado: new Date,
    creadoPor: '',
    dosificacion: '',
    CodigoUnicoRecord:''
}
const modeloHistoriaClinica = {
    historiID: 0,
    pacienteID: 0,
    empresaID: 1,
    nombrePaciente: '',
    edad: 0,
    seguroID: 0,
    nombreSegro: '',
    historiaEnfermedadActual: '',
    tiempoEvoluccion: '',
    antecedentePatologicoPersonales: '',
    estudiosRealizado: '',
    tratamientoPrevios: '',
    procedimientoSolicitado: '',
    fecha: new Date,
 creadoPor: '',
    fechaCreado: new Date,
    tipoReporte: 1,
    constatado: '',
    recomiendo: ''
   
}

const modeloDatosEmpresa = {
    empresaID: 0,
    siglas: "",
    descripcion: "",
    rnc: "",
    telefono: 1,
    direccion: "",
    email: "",
    creadoPor: "",
    modificadoPor: "",
    fechaCreado: new Date,
    fechaModificado: new Date,
    estatus: true,
    logo: "",
    noWhatsapp: "",
    tokenWhatsapp: "",
    plantillaWhatsapp: ""

}
const modeloDataDiente = {
    id: 0,
    recordID: 0,
    pacienteID: 0,
    noDiente: 0, 
    noCara: 0, 
    caraDiente: '',
    historia: '',
    comentario:''

}
let options = [];
let optionsT = [{ descripcion: "" }];

let DetalleReceta = "";
const Odontologia = () => {
     emp = JSON.parse(localStorage.getItem("sesion_usuario")).empresaID;
   
    const [tablaHistoria, setTablaHistoria] = useState(modeloHistoriaClinica);
    const [tabla, setTabla] = useState(modeloDatos);
    const [tablaD, setTablaD] = useState(modeloDataDiente);
    const [tablaT, setTablaT] = useState([]);
    const [tablaRecord, setTablaRecord] = useState(modeloRecord);
    const [tablaReceta, setTablaReceta] = useState(modeloReceta);
    const [Listado, SetListado] = useState([]);
    const [ListadoD, SetListadoD] = useState([]);
    const [ListadoHistoria, SetListadoHistoria] = useState([]);
    const [ListadoSeg, SetListadoSeg] = useState([]);
    const [ListadoTox, SetListadoTox] = useState([]);
    const [ListadoRecord, SetListadoRecord] = useState([]);
    const [ListadoReceta, SetListadoReceta] = useState([]);
    const [ListadoMedicamento, SetListaMedicamento] = useState([]);
    const [pendiente, setPendiente] = useState(true);
    const [verModal, setVerModal] = useState(false);
    const [user, setUser] = useState(window.localStorage.getItem("sesion_usuario"))
    const [Listado1, SetListado1] = useState([]);
    const [paciente, Setpaciente] = useState([]);
    const [Camara, SetCamara] = useState(false);
    const [Receta, SetReceta] = useState(false);
    const [Verrecord, SetVerrecord] = useState(false);
    const [VerEvaluacionPre, SetVerEvaluacionPre] = useState(false);
    const [NombreReceta, SetNombreReceta] = useState("");

    const [Inicio, SetInicio] = useState(false);
    const [pacientenombres, Setpacientenombres] = useState(new Date);
    const [verModalImpresion, setVerModalImpresion] = useState(false);
    const [verModalImpresion1, setVerModalImpresion1] = useState(false);
    const [VerDientes, setVerDientes] = useState(false);
    const [Empresa, setEmpresa] = useState(modeloDatosEmpresa);
    const [EvaluacionQ, setEvaluacionQ] = useState("")
    const [EvaluacionM, setEvaluacionM] = useState("")
    const [EvaluacionR, setEvaluacionR] = useState(``);
    


    //toast.configure();
    

    let correo = JSON.parse(user).correo;
    const onBusqueda = async (e) => {
        var l = Listado1;
       
        var searchData = l.filter((item) => {
            if (
                (item.nombres + item.apellidos + item.cedula + item.telefono)
                    .toString()
                    .toLowerCase()
                    .includes(e.target.value.toLowerCase())
            
            ) {
                return item;
            }
        });
        SetListado(searchData);
    };

   

    const handleChange = (e) => {
        //let value = e.target.nodeName === "SELECT" ? (e.target.value == "true" ? true : false) : e.target.value;
        let value = e.target.value
        if (value == 'true') { value = false}
        if (value == 'false') {value = true }
        if (value == '0') { value = 0}
        if (value == '1') {value = 1 }
        if (e.target.name == "sexo") {
            icono(value)
        }
        if (e.target.name == "cedula" && e.target.value.length > 10) {
            ValidarCedula(value);
        }
        else {
        setTabla({
            ...tabla,
            [e.target.name]: e.target.value
        })
    }
    }
    const handleChangeRecord = (e) => {
        //let value = e.target.nodeName === "SELECT" ? (e.target.value == "true" ? true : false) : e.target.value;
        setTablaRecord({
            ...tablaRecord,
            [e.target.name]: e.target.value
        })
    }
    const handleChangeReceta = (e) => {
        //let value = e.target.nodeName === "SELECT" ? (e.target.value == "true" ? true : false) : e.target.value;
        setTablaReceta({
            ...tablaReceta,
            [e.target.name]: e.target.value
        })
    }

    const handleChangeHistoria = (e) => {
        //let value = e.target.nodeName === "SELECT" ? (e.target.value == "true" ? true : false) : e.target.value;
        setTablaHistoria({
            ...tablaHistoria,
            [e.target.name]: e.target.value
        })
    }
    const handleChangeDiente = (e) => {
        //let value = e.target.nodeName === "SELECT" ? (e.target.value == "true" ? true : false) : e.target.value;
        setTablaD({
            ...tablaD,
            [e.target.name]: e.target.value
        })
    }

    const handleChange2 = (e) => {
        setTablaReceta({
            ...tablaReceta,
            ["medicamentoID"]: e.value, ["nombreMedicamento"]: e.nombre, ["pacienteiD"]: paciente.pacienteID, ["recordPacienteID"]: tablaRecord.recordPacienteGastroID
        })
    }
    const handleChange3 = (e) => {
        setTablaReceta({
            ...tablaReceta,
            ["medicamentoID"]: 1, ["nombreMedicamento"]: e.value, ["pacienteiD"]: paciente.pacienteID, ["recordPacienteID"]: tablaRecord.recordPacienteGastroID
        })
    }
 


    const ValidarCedula = async (x) => {

        var nomb = Listado.filter(e => e.cedula == x).map(d => d);
        setTabla({
            ...tabla, nombres: "", apellidos: "", cedula: x
        })
        if (nomb.length != 0) {
            var e = nomb[0].nombres + " EXISTE"
            MensajeG(e)
            setVerModal(!verModal);
            Setpaciente(nomb[0])
        }
        else {
            let response1 = await fetch(Api + "administracion/ConsultaCed/" + x);
            if (response1.ok) {
                let data1 = await response1.json()
                if (data1 != false) {
                    icono((data1[0]).sexo);
                    setTabla({
                        ...tabla, nombres: (data1[0]).nombres, apellidos: (data1[0]).apellido1 + " " + (data1[0]).apellido2, cedula: x,
                        fechaNacimiento: (data1[0]).fechaNacimiento, sexo: (data1[0]).sexo
                    })
                } else {
                    setTabla({
                        ...tabla, nombres: "", apellidos:"",cedula: x
                    })
                }
            }
        }
    }

    const MensajeG= (e) => toast.success(e, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",

    });

    const obtenerDatos = async () => {
        let response = await fetch(Api + "Odontologia/ListaOdontologia/" + correo +"/"+emp);
        if (response.ok) {
            let data1 = await response.json()
            let data = data1;
             
            SetListado1(data);
            setPendiente(false)
            
            if (Inicio == false) {
                SetListado(data);
                SetInicio(true);
            }
          
           
            
        }
    }

    const obtenerDatosSeg = async () => {
        let response = await fetch(Api + "CMantenimiento/ListaSeguros/" + correo + "/"+emp);
        if (response.ok) {
            let data = await response.json()
            SetListadoSeg(data)
        }
    }

    const obtenerDatosHistoria = async (e) => {
        let response = await fetch(Api + "Pacientes/ListaHistoriaGastro/" + e + "/" + emp);
        if (response.ok) {
            let data = await response.json()
            SetListadoHistoria(data)
        }
    }

    const ObtenerRecord = async (d) => {
        let response = await fetch(Api + "Odontologia/ListaRecordPaciente/" + d + "/" + emp);
        if (response.ok) {
            let data = await response.json()
            SetListadoRecord(data)
        }
    }
    const ObtenerReceta = async (d, v) => {
        let response = await fetch(Api + "Odontologia/Recetas/" + d + "/" + emp);
        if (response.ok) {
            let data = await response.json()
            SetListadoReceta(data)
        } if (v == 1) {
            SetReceta(true)
        }
    }
    const obtenerDatosEmpresa = async (d, v) => {
        let response = await fetch(Api + "Pacientes/Empresa/" + emp);
        if (response.ok) {
            let data = await response.json()
            setEmpresa(data)
        } 
    }
    const ObtenerMedicamento = async () => {
        let response = await fetch(Api + "Odontologia/Medicamentos/"+ emp);
        if (response.ok) {
            options=[]
            let data = await response.json()
            SetListaMedicamento(data)
            data.map(x => {
                options.push({
                    value: x.medicamentoID, label: x.descripcion , nombre: x.descripcion
                       })
            })
        }
    }


    useEffect(() => {
        obtenerDatos();
        obtenerDatosEmpresa();
        obtenerDatosSeg();
      
    }, [])

        useEffect(() => {
            ObtenerMedicamento();
            obtenerDatosToxico();
    }, [])


    const abrirRecord = (data) => {
        Setpaciente(data);
        ObtenerRecord(data.pacienteID);
    }

    const mostrarMensaje = () => {
        Swal.fire({
            title: 'ERROR',
            text: "No puedes guardar si hay un elemento Activo.  Favor inactivar el elemento. ",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            //confirmButtonText: 'Si, continuar',
            cancelButtonText: 'volver'
        }).then((result) => {
            //alert(result.value)
            if (result.value) {


            }
        })

    }


    const guardarCambios = async () => {
        let response;
        var editando = 0;
        if (tabla.pacienteID == 0) {
            tabla.creadoPor = JSON.parse(user).correo;
            response = await fetch(Api + "Odontologia/GuardarOdontologia", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })
            setVerModal(!verModal);
        } else {
            tabla.modificadoPor = JSON.parse(user).correo;
            response = await fetch(Api + "Odontologia/EditarOdontologia", {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })

            editando = 1;
        }

        if (response.ok) {
            SetInicio(false);
            obtenerDatos();
      
            let data1 = await response.json()
            if (editando == 0) {
                Setpaciente(data1)
            }
            if (data1 == false) {
                mostrarMensaje()
            } else {
                await obtenerDatos();
                setTabla(modeloDatos)
                setVerModal(!verModal);
            }
         
            MensajeG("Guardado")
       
        } else {
            alert("error al guardar")
        }

    }
    const guardarCambiosRecord = async () => {
        let response;
        if (tablaRecord.recordPacienteID == 0) {
            tablaRecord.pacienteID = paciente.pacienteID;
            response = await fetch(Api + "Odontologia/GuardarRecordPaciente", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tablaRecord)
            })
 
        } else {
            response = await fetch(Api + "Odontologia/EditarRecordPaciente", {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tablaRecord)
            })
        }

        if (response.ok) {
            let data1 = await response.json()
            tablaRecord.recordPacienteGastroID = data1.recordPacienteGastroID
            tablaRecord.codigoUnico = data1.codigoUnico
            
            await ObtenerRecord();
            MensajeG("Guardado")
           // setTablaRecord(modeloRecord);
            SetReceta(true);
       
        } else {
            alert("error al guardar")
        }

    }

    const GuardarHistoriaGastro = async () => {
        let response;
        if (tablaHistoria.historiID == 0) {
            response = await fetch(Api + "Pacientes/GuardarHistoriaGastro", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tablaHistoria)
            })
 
        } else {
            response = await fetch(Api + "Pacientes/EditarHistoriaGastro", {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tablaHistoria)
            })
        }

        if (response.ok) {
            let data1 = await response.json()
                       
            await obtenerDatosHistoria(tablaHistoria.pacienteID);
            MensajeG("Guardado")
        
       
        } else {
            alert("error al guardar")
        }

    }
    const guardarCambiosReceta = async () => {
        let response;
        if (tablaReceta.recetaID == 0) {
            tablaRecord.pacienteID = paciente.pacienteID;
            tablaRecord.empresaID = paciente.empresaID;
            
            response = await fetch(Api + "Pacientes/GuardarReceta", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tablaReceta)
            })
        } else {
            response = await fetch(Api + "Pacientes/EditarReceta", {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tablaReceta)
            })
        }

        if (response.ok) {

            await ObtenerReceta(tablaRecord.recordPacienteGastroID);
          
            SetReceta(modeloReceta);
            MensajeG()
           // Setpaciente([]);
       
        } else {
            alert("error al guardar")
        }

    }
    const EliminarReceta = async (id) => {
        const response = fetch(Api + "Pacientes/EliminarReceta/" + id, { method: "DELETE" })
            .then(response => {
                if (response.ok) {
                    ObtenerReceta(tablaRecord.recordPacienteGastroID)
                }
            })}
    const eliminarDatos = async (id) => {

        Swal.fire({
            title: 'Esta seguro?',
            text: "Desea eliminar el producto",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, continuar',
            cancelButtonText: 'No, volver'
        }).then((result) => {
            if (result.value) {
                const response = fetch(Api + "Citas/EliminarEspecialistas/" + id, { method: "DELETE" })
                    .then(response => {
                        if (response.ok) {
                            SetInicio(false)
                            obtenerDatos();
                            Swal.fire(
                                'Eliminado!',
                                'El producto fue eliminado.',
                                'success'
                            )
                        }
                    })
            }
        })
    }

    const HistoriaClinica = (data) => {
        obtenerDatosHistoria(data.pacienteID)
        tablaHistoria.pacienteID = data.pacienteID;
        tablaHistoria.nombrePaciente = data.nombres + ' ' + data.apellidos;
        tablaHistoria.edad =  calcularEdad(data.fechaNacimiento,moment(new Date()).format("YYYY-MM-DD")) ;
        tablaHistoria.seguroID = data.seguroID;
        tablaHistoria.nombreSeguro = data.nombreSeguro;
        tablaHistoria.antecedentePatologicoPersonales = data.antecedentesMedicos;
        setVerModalImpresion(!verModalImpresion);
    }
    const HistoriaClinica2 = (data) => {
        obtenerDatosHistoria(data.pacienteID)
        tablaHistoria.pacienteID = data.pacienteID;
        tablaHistoria.nombrePaciente = data.nombres + ' ' + data.apellidos;
        tablaHistoria.edad =  calcularEdad(data.fechaNacimiento,moment(new Date()).format("YYYY-MM-DD")) ;
        tablaHistoria.seguroID = data.seguroID;
        tablaHistoria.nombreSeguro = data.nombreSeguro;
        tablaHistoria.sexo = data.sexo;
        tablaHistoria.antecedentePatologicoPersonales = data.antecedentesMedicos;
      setEvaluacionQ(""   );
     SetVerEvaluacionPre(true)  
    }
    const HistoriaClinica1 = (data) => {
        tabla.cedula = data.cedula
        obtenerDatosHistoria(data.pacienteID)
        tablaHistoria.pacienteID = data.pacienteID;
        tablaHistoria.nombrePaciente = data.nombres + ' ' + data.apellidos;
        tablaHistoria.edad = calcularEdad(data.fechaNacimiento, new Date()) ;
        tablaHistoria.seguroID = data.seguroID;
        tablaHistoria.nombreSeguro = data.nombreSeguro;
        tablaHistoria.antecedentePatologicoPersonales = data.antecedentesMedicos;
        setVerModalImpresion1(!verModalImpresion1);
    }
    
    const RecetaEnBlanco =async (data) => {
      
        SetNombreReceta("alejra")
        imprimirRecibo3()
    }
   

      

    const abrirEditarModal = (data) => {
        setTabla(data);
        setVerModal(!verModal);
    }
    const cerrarModal = () => {
        setTabla(modeloDatos)
        setVerModal(false)
        setVerModalImpresion(false)
        setVerModalImpresion1(false)
        setVerDientes(false)
    }

    const columns = [
 
        {
            name: 'Pacientes ',
            selector: row => row.nombres +" "+ row.apellidos ,
            sortable: true,
            width: window.innerWidth < 768 ? '25%' : '',
     
        },
        {
            name: 'Telefono ',
            selector: row => row.telefono,
            sortable: true,
            omit: window.innerWidth < 768
         
        }, {
            name: 'Seguro ',
            selector: row => ( row.nombreSeguro),
            sortable: true,
            omit: window.innerWidth < 768
        },

        {
            name: 'IMPORTANTE RECORDAR ',
            selector: row => (row.diagnosticoClinico),
            sortable: true,
            style: {
                color: "red"

            },
            omit: window.innerWidth < 768
        },
        {
            name: 'Ultima Consulta',
            selector: row => (moment( row.fechavisita).format("DD/MM/YYYY")),
            sortable: true,
            width: window.innerWidth < 768 ? '20%' : '',
        },


       
        {
            name: '',
           
            cell: row => (
                <>
                   
                   
                    <Button class="btn" size="sm" className="mr-2"
                        onClick={() => abrirEditarModal(row)}
                    >
                        <i className="fas fa-pen-alt"></i>
                    </Button>
                    <Button color="primary" size="sm" className="mr-2"
                        onClick={() => abrirRecord(row)}
                    >
                        <i className="fas fa-user-tag"></i>
                    </Button>
                    <div class="btn-group">
                        <button type="button" class="btn mr-2  dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            ACCIONES
                        </button>
                        <div class="dropdown-menu">
                            <Button class="btn" size="sm" color="warning" size="sm" className="mr-2"
                                onClick={() => HistoriaClinica1(row)}
                            >
                                CERTIFICADO
                            </Button>
                            <div class="dropdown-divider"></div>
                            <Button class="btn" color="warning" size="sm" className="mr-2"
                                onClick={() => HistoriaClinica(row)}
                            >
                                HISTORIA CLINICA
                            </Button>
                            <div class="dropdown-divider"></div>
                            <Button class="btn" color="warning" size="sm" className="mr-2"
                                onClick={() => HistoriaClinica2(row)}
                            >
                                EVALUACIÓN PRE-QUIRÚRGICA
                            </Button>
                            <div class="dropdown-divider"></div>
                            <Button class="btn" color="warning" size="sm" className="mr-2"
                                onClick={() => RecetaEnBlanco(row)}
                            >
                                Receta Blanca
                            </Button>

                        </div>
                    </div>

                </>
            ),
        },
    ];

    const customStyles = {
        headCells: {
            style: {
                fontSize: '12px',
                fontWeight: 800,
            },
        },
        headRow: {
            style: {
                backgroundColor: "#eee",
            }
        }
    };

    const paginationComponentOptions = {
        rowsPerPageText: 'Filas por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };

        const Atras =() =>{
        Setpaciente([])
    }
    const TerminarReceta = (d) => {
       
        if (d != '0') {
            imprimirRecibo3()
        //    window.open("/ImpresionReceta/" + d + "/ImpresionReceta.html" + "/Gastro", '_blank');
        }
        
        obtenerDatos()
        Setpaciente([])
        setTablaReceta(modeloReceta)
        setTablaRecord(modeloRecord)
        SetReceta(false)
     
    }
    const icono = (d)=> {
        const profileIcon = document.getElementById('profileIcon');
        if (d === 'F') {
            profileIcon.innerHTML = '👩';
        } else if (d === 'M') {
            profileIcon.innerHTML = '👨';
        } else {
            profileIcon.innerHTML = '👤';
        }
    };


    const obtenerDatosToxico = async () => {
        let response = await fetch(Api + "CMantenimiento/listaToxicos");
        if (response.ok) {
            let data = await response.json()
            SetListadoTox(data)
      
        }
    }

    function calcularEdad(fechaNacimiento, fechaActual) {
        var nacimiento = new Date(fechaNacimiento);
        var actual = new Date(fechaActual);

        var edad = actual.getFullYear() - nacimiento.getFullYear();
        var mes = actual.getMonth() - nacimiento.getMonth();
        var dia = actual.getDate() - nacimiento.getDate();

        // Ajustar si el mes o el día no ha pasado aún este año
        if (mes < 0 || (mes === 0 && dia < 0)) {
            edad--;
        }

        return edad;
    }
    const [cssContent, setCssContent] = useState('');
    useEffect(() => {
        fetch('/css/Gastro.css')
            .then(response => response.text())
            .then(text => setCssContent(text))
            .catch(error => console.error('Error al cargar el CSS:', error));
    }, []);

    const imprimirRecibo = () => {
        const recibo = document.getElementById("reciboPago").innerHTML;
        const ventana = window.open("", "", "width=600,height=400");
        ventana.document.write("<html><head>   <title>Historia clinica</title><style>");
        ventana.document.write(cssContent);
        ventana.document.write("</style></head><body>");
        ventana.document.write(` <div class="headerM container"> 
                            <img id="logoImg" class="card-img-top" src="./imagen/LogoGastro.jpg" style="width: 80%;" />
                        </div>      ${recibo}  </body></html>`);
        ventana.document.close();
        // Esperar a que la imagen cargue antes de imprimir
        const logoImg = ventana.document.getElementById("logoImg");
        logoImg.onload = function () {
            ventana.print();
        };
    };


    const imprimirRecibo1 = () => {
        const recibo1 = document.getElementById("reciboPago1").innerHTML;
        const ventana = window.open("", "", "width=600,height=400");
        ventana.document.write("<html><head>   <title>Certificado</title><style>");
        ventana.document.write(cssContent);
        ventana.document.write("</style></head><body>");
        ventana.document.write(` <div "> 
                          
                        </div>      ${recibo1}  </body></html>`);
        ventana.document.close();
        // Esperar a que la imagen cargue antes de imprimir
        const logoImg1 = ventana.document.getElementById("logoImg1");
      ventana.print(); 
    };


    const imprimirRecibo2 = () => {
        const recibo1 = document.getElementById("reciboPago2").innerHTML;
        const ventana = window.open("", "", "width=600,height=400");
        ventana.document.write("<html><head>   <title></title><style>");
        ventana.document.write(cssContent);
        ventana.document.write(`</style></head><body style="color:#000">`);
        ventana.document.write(` <div "> 
                          
                        </div>      ${recibo1}  </body></html>`);
        ventana.document.close();
        // Esperar a que la imagen cargue antes de imprimir
        const logoImg1 = ventana.document.getElementById("logoImg1");
        ventana.print();
    };

    const imprimirRecibo3 = () => {
       
        const recibo1 = document.getElementById("reciboPago3").innerHTML;
        const ventana = window.open("", "", "width=600,height=400");
        ventana.document.write("<html><head>   <title></title><style>");
        ventana.document.write(cssContent);
        ventana.document.write(`</style></head><body style="color:#000">`);
        ventana.document.write(` <div "> 
                          
                        </div>      ${recibo1}  </body></html>`);
        ventana.document.close();
        // Esperar a que la imagen cargue antes de imprimir
        const logoImg1 = ventana.document.getElementById("logoImg1");
        ventana.print();
    };

    const RimprimirRecibo =  async(d) => {
        setTablaHistoria(d)
     
    }
    const cerrarModalR = () => {
        setTablaRecord(modeloRecord)
        SetVerrecord(false)
        SetVerEvaluacionPre(false)
    }

    const GuardarDiente = () => {

        SetListadoD([
            ...ListadoD,
            tablaD
        ])
    }


    //odontograma
    document.querySelectorAll('.cara').forEach(cara => {
        cara.addEventListener('click', () => {
            cara.classList.toggle('activa');
            const seccion = Array.from(cara.classList).find(cls => ['superior', 'inferior', 'izquierda', 'derecha', 'central'].includes(cls));
            const diente = cara.closest('.diente').getAttribute('data-numero');
            document.getElementById('info').textContent = `Diente ${diente} - Cara ${seccion.toUpperCase()}`;
           {
                const nuevoEstado = {
                    ...tablaD,
                    caraDiente: seccion.toUpperCase(),
                    noDiente: diente
                };

                setTablaD(nuevoEstado);
                setVerDientes(true)
      
            }
           
           

        });
    });
    return (
        <>

            <ToastContainer />
            <div hidden={paciente.length == 0} >


                <div class="containerR">

                    <div class="">

                        <h1>Consulta Médica</h1>
                    </div>
                    <div class="patient-info">
                        <div class="info-item">
                            <span class="info-label">Nombres y Apellidos:</span>
                            {paciente.nombres + " " + paciente.apellidos}
                        </div>
                        <div class="info-item">
                            <span class="info-label">Edad:</span>

                            {calcularEdad(paciente.fechaNacimiento, new Date())}
                        </div>
                        <div class="info-item">
                            <span class="info-label">Móvil:</span>
                            {paciente.celular} /  {paciente.telefono}
                        </div>
                        <div class="info-item">
                            <span class="info-label">ARS:</span>
                            {paciente.nombreSeguro}
                        </div>
                        <div class="info-item">
                            <span class="info-label">Afiliado:</span>
                            {paciente.poliza}
                        </div>
                        <div class="info-item">
                            <span class="info-label">Tóxicos:</span>
                            {paciente.toxicos}
                        </div>
                        <div class="info-item">
                            <span class="info-label">Alergicos:</span>
                            {paciente.alergicos}
                        </div>
                        <div class="info-item">
                            <span class="info-label">Antecedentes Medicos:</span>
                            {paciente.antecedentesMedicos}
                        </div>
                        <div class="info-item">
                            <span class="info-label">Antecedentes Medicamentos:</span>
                            {paciente.antecedentesMedicamentos}
                        </div>
                        <div class="info-item" style={{ color: "red" }}>
                            <span class="info-label" style={{ color: "red" }}>MUY IMPORTANTE RECORDAR:</span>
                            {paciente.diagnosticoClinico}
                        </div>
                    </div>
                    <div className="bodyodo">

                        <h2>Odontograma Interactivo Completo</h2>

                        <div id="info">Selecciona una cara dental para ver la información</div>
                        <div class="numeros">
                            <div class="numero-diente">18</div>
                            <div class="numero-diente">17</div>
                            <div class="numero-diente">16</div>
                            <div class="numero-diente">15</div>
                            <div class="numero-diente">14</div>
                            <div class="numero-diente">13</div>
                            <div class="numero-diente">12</div>
                            <div class="numero-diente">11</div>
                            <div class="numero-diente">21</div>
                            <div class="numero-diente">22</div>
                            <div class="numero-diente">23</div>
                            <div class="numero-diente">24</div>
                            <div class="numero-diente">25</div>
                            <div class="numero-diente">26</div>
                            <div class="numero-diente">27</div>
                            <div class="numero-diente">28</div>
                        </div>
                        <div class="odontograma">

                            <div class="diente" data-numero="18">
                                <div class="cara superior"></div>
                                <div class="cara inferior"></div>
                                <div class="cara izquierda"></div>
                                <div class="cara derecha"></div>
                                <div class="cara central"></div>
                                <div class="numero">18</div>
                            </div>


                            <div class="diente" data-numero="17">
                                <div class="cara superior"></div>
                                <div class="cara inferior"></div>
                                <div class="cara izquierda"></div>
                                <div class="cara derecha"></div>
                                <div class="cara central"></div>
                                <div class="numero">17</div>
                            </div>


                            <div class="diente" data-numero="16">
                                <div class="cara superior"></div>
                                <div class="cara inferior"></div>
                                <div class="cara izquierda"></div>
                                <div class="cara derecha"></div>
                                <div class="cara central"></div>
                                <div class="numero">16</div>
                            </div>


                            <div class="diente" data-numero="15">
                                <div class="cara superior"></div>
                                <div class="cara inferior"></div>
                                <div class="cara izquierda"></div>
                                <div class="cara derecha"></div>
                                <div class="cara central"></div>
                                <div class="numero">15</div>
                            </div>


                            <div class="diente" data-numero="14">
                                <div class="cara superior"></div>
                                <div class="cara inferior"></div>
                                <div class="cara izquierda"></div>
                                <div class="cara derecha"></div>
                                <div class="cara central"></div>
                                <div class="numero">14</div>
                            </div>


                            <div class="diente" data-numero="13">
                                <div class="cara superior"></div>
                                <div class="cara inferior"></div>
                                <div class="cara izquierda"></div>
                                <div class="cara derecha"></div>
                                <div class="cara central"></div>
                                <div class="numero">13</div>
                            </div>


                            <div class="diente" data-numero="12">
                                <div class="cara superior"></div>
                                <div class="cara inferior"></div>
                                <div class="cara izquierda"></div>
                                <div class="cara derecha"></div>
                                <div class="cara central"></div>
                                <div class="numero">12</div>
                            </div>


                            <div class="diente" data-numero="11">
                                <div class="cara superior"></div>
                                <div class="cara inferior"></div>
                                <div class="cara izquierda"></div>
                                <div class="cara derecha"></div>
                                <div class="cara central"></div>
                                <div class="numero">11</div>
                            </div>


                            <div class="diente" data-numero="21">
                                <div class="cara superior"></div>
                                <div class="cara inferior"></div>
                                <div class="cara izquierda"></div>
                                <div class="cara derecha"></div>
                                <div class="cara central"></div>
                                <div class="numero">21</div>
                            </div>


                            <div class="diente" data-numero="22">
                                <div class="cara superior"></div>
                                <div class="cara inferior"></div>
                                <div class="cara izquierda"></div>
                                <div class="cara derecha"></div>
                                <div class="cara central"></div>
                                <div class="numero">22</div>
                            </div>


                            <div class="diente" data-numero="23">
                                <div class="cara superior"></div>
                                <div class="cara inferior"></div>
                                <div class="cara izquierda"></div>
                                <div class="cara derecha"></div>
                                <div class="cara central"></div>
                                <div class="numero">23</div>
                            </div>


                            <div class="diente" data-numero="24">
                                <div class="cara superior"></div>
                                <div class="cara inferior"></div>
                                <div class="cara izquierda"></div>
                                <div class="cara derecha"></div>
                                <div class="cara central"></div>
                                <div class="numero">24</div>
                            </div>


                            <div class="diente" data-numero="25">
                                <div class="cara superior"></div>
                                <div class="cara inferior"></div>
                                <div class="cara izquierda"></div>
                                <div class="cara derecha"></div>
                                <div class="cara central"></div>
                                <div class="numero">25</div>
                            </div>


                            <div class="diente" data-numero="26">
                                <div class="cara superior"></div>
                                <div class="cara inferior"></div>
                                <div class="cara izquierda"></div>
                                <div class="cara derecha"></div>
                                <div class="cara central"></div>
                                <div class="numero">26</div>
                            </div>


                            <div class="diente" data-numero="27">
                                <div class="cara superior"></div>
                                <div class="cara inferior"></div>
                                <div class="cara izquierda"></div>
                                <div class="cara derecha"></div>
                                <div class="cara central"></div>
                                <div class="numero">27</div>
                            </div>


                            <div class="diente" data-numero="28">
                                <div class="cara superior"></div>
                                <div class="cara inferior"></div>
                                <div class="cara izquierda"></div>
                                <div class="cara derecha"></div>
                                <div class="cara central"></div>
                                <div class="numero">28</div>
                            </div>
                        </div>
                        <div class="numeros">
                            <div class="numero-diente">48</div>
                            <div class="numero-diente">47</div>
                            <div class="numero-diente">46</div>
                            <div class="numero-diente">45</div>
                            <div class="numero-diente">44</div>
                            <div class="numero-diente">43</div>
                            <div class="numero-diente">42</div>
                            <div class="numero-diente">41</div>
                            <div class="numero-diente">31</div>
                            <div class="numero-diente">32</div>
                            <div class="numero-diente">33</div>
                            <div class="numero-diente">34</div>
                            <div class="numero-diente">35</div>
                            <div class="numero-diente">36</div>
                            <div class="numero-diente">37</div>
                            <div class="numero-diente">38</div>
                        </div>
                        <div class="odontograma">

                            <div class="diente" data-numero="48">
                                <div class="cara superior"></div>
                                <div class="cara inferior"></div>
                                <div class="cara izquierda"></div>
                                <div class="cara derecha"></div>
                                <div class="cara central"></div>
                                <div class="numero">48</div>
                            </div>


                            <div class="diente" data-numero="47">
                                <div class="cara superior"></div>
                                <div class="cara inferior"></div>
                                <div class="cara izquierda"></div>
                                <div class="cara derecha"></div>
                                <div class="cara central"></div>
                                <div class="numero">47</div>
                            </div>


                            <div class="diente" data-numero="46">
                                <div class="cara superior"></div>
                                <div class="cara inferior"></div>
                                <div class="cara izquierda"></div>
                                <div class="cara derecha"></div>
                                <div class="cara central"></div>
                                <div class="numero">46</div>
                            </div>


                            <div class="diente" data-numero="45">
                                <div class="cara superior"></div>
                                <div class="cara inferior"></div>
                                <div class="cara izquierda"></div>
                                <div class="cara derecha"></div>
                                <div class="cara central"></div>
                                <div class="numero">45</div>
                            </div>


                            <div class="diente" data-numero="44">
                                <div class="cara superior"></div>
                                <div class="cara inferior"></div>
                                <div class="cara izquierda"></div>
                                <div class="cara derecha"></div>
                                <div class="cara central"></div>
                                <div class="numero">44</div>
                            </div>


                            <div class="diente" data-numero="43">
                                <div class="cara superior"></div>
                                <div class="cara inferior"></div>
                                <div class="cara izquierda"></div>
                                <div class="cara derecha"></div>
                                <div class="cara central"></div>
                                <div class="numero">43</div>
                            </div>


                            <div class="diente" data-numero="42">
                                <div class="cara superior"></div>
                                <div class="cara inferior"></div>
                                <div class="cara izquierda"></div>
                                <div class="cara derecha"></div>
                                <div class="cara central"></div>
                                <div class="numero">42</div>
                            </div>


                            <div class="diente" data-numero="41">
                                <div class="cara superior"></div>
                                <div class="cara inferior"></div>
                                <div class="cara izquierda"></div>
                                <div class="cara derecha"></div>
                                <div class="cara central"></div>
                                <div class="numero">41</div>
                            </div>


                            <div class="diente" data-numero="31">
                                <div class="cara superior"></div>
                                <div class="cara inferior"></div>
                                <div class="cara izquierda"></div>
                                <div class="cara derecha"></div>
                                <div class="cara central"></div>
                                <div class="numero">31</div>
                            </div>


                            <div class="diente" data-numero="32">
                                <div class="cara superior"></div>
                                <div class="cara inferior"></div>
                                <div class="cara izquierda"></div>
                                <div class="cara derecha"></div>
                                <div class="cara central"></div>
                                <div class="numero">32</div>
                            </div>


                            <div class="diente" data-numero="33">
                                <div class="cara superior"></div>
                                <div class="cara inferior"></div>
                                <div class="cara izquierda"></div>
                                <div class="cara derecha"></div>
                                <div class="cara central"></div>
                                <div class="numero">33</div>
                            </div>


                            <div class="diente" data-numero="34">
                                <div class="cara superior"></div>
                                <div class="cara inferior"></div>
                                <div class="cara izquierda"></div>
                                <div class="cara derecha"></div>
                                <div class="cara central"></div>
                                <div class="numero">34</div>
                            </div>


                            <div class="diente" data-numero="35">
                                <div class="cara superior"></div>
                                <div class="cara inferior"></div>
                                <div class="cara izquierda"></div>
                                <div class="cara derecha"></div>
                                <div class="cara central"></div>
                                <div class="numero">35</div>
                            </div>


                            <div class="diente" data-numero="36">
                                <div class="cara superior"></div>
                                <div class="cara inferior"></div>
                                <div class="cara izquierda"></div>
                                <div class="cara derecha"></div>
                                <div class="cara central"></div>
                                <div class="numero">36</div>
                            </div>


                            <div class="diente" data-numero="37">
                                <div class="cara superior"></div>
                                <div class="cara inferior"></div>
                                <div class="cara izquierda"></div>
                                <div class="cara derecha"></div>
                                <div class="cara central"></div>
                                <div class="numero">37</div>
                            </div>


                            <div class="diente" data-numero="38">
                                <div class="cara superior"></div>
                                <div class="cara inferior"></div>
                                <div class="cara izquierda"></div>
                                <div class="cara derecha"></div>
                                <div class="cara central"></div>
                                <div class="numero">38</div>
                            </div>

                        </div>

                    </div>

                    <div class="col-md-12" >

                        {ListadoD.map(x => (
                            <div>Diente:  {x.noDiente} cara: {x.caraDiente}  Proceso: {x.historia} Comentario: { x.comentario}</div> 
                        )) }

                        <Row>
                            <div className="col-md-6">
                                <h4><b>Consulta</b></h4>
                                <textarea placeholder="Historia Clínica" name="historiaClinica"
                                    onChange={handleChangeRecord} value={tablaRecord.historiaClinica} ></textarea>
                                <textarea placeholder="Comentario" name="comentario" value={tablaRecord.comentario}
                                    onChange={handleChangeRecord}></textarea>

                                <div class="btn-group">
                                    <button type="button" onClick={Atras} class="btn btn-danger">Cerrar</button>
                                    <button type="button" class="btn btn-primary" onClick={guardarCambiosRecord} hidden={!tablaRecord.historiaClinica}>Siguiente</button>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <h4><b>Historial de consulta</b></h4>
                                <table >
                                    <thead>
                                        <tr>
                                            <th>Fecha  </th>
                                            <th>Descripción</th>
                                            <th>Comentario</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {ListadoRecord.map(x => (
                                            <tr>
                                                <td>{moment(x.fecha).format("DD/MM/YY")}</td>
                                                <td >
                                                    <textarea rows="2" value={x.historiaClinica} disabled></textarea>
                                                </td>
                                                <td>
                                                    <textarea rows="2" value={x.comentario} disabled></textarea>
                                                </td>
                                                <td><Button class="print-icon" target="_blank"
                                                    onClick={() => ObtenerReceta(x.recordPacienteGastroID,1)}                                                
                                                >🖨️</Button></td>

                                            </tr>
                                        ))}

                                    </tbody>
                                </table>
                            </div>
                        </Row>
                    </div>
                </div>
            </div>






            <Col md="12" hidden={paciente.length != 0}>
                <Card>
                    <CardHeader style={{ backgroundColor: '#4e73df', color: "white" }}>
                        <Row>
                            {/*<Col hidden md="2" ><Input type="date" onChange={(e)=>SetFechaF(e.target.value) } />  </Col>*/}
                            <Col md="8" >
                                <Input type="search" name="busqueda" onChange={(e) => onBusqueda(e)} placeholder="Busqueda de paciente " ></Input></Col>

                            <Col md="4" >

                                <Button color="success" size="md"
                                    onClick={() => setVerModal(!verModal)}
                                ><b>Nuevo Paciente</b></Button>
                                <Button color="warning" size="md"
                                    href="/ReportesGastro"
                                ><b>Reporte</b></Button>
                            </Col></Row>
                    </CardHeader>
                    <CardBody>

                        <DataTable
                            columns={columns}
                            data={Listado}
                            progressPending={pendiente}
                            pagination
                            paginationComponentOptions={paginationComponentOptions}
                            customStyles={customStyles}


                        />
                    </CardBody>
                </Card>
            </Col>



            <Modal className="modal-preguntas" isOpen={verModal}>

                <ModalBody>


                    {/*                   <Row>*/}

                    <div class="containerp">
                        <div class="form-header">
                            <div class="box">
                                <div>Record del Paciente </div>
                                <div><a className="btn" style={{ color: "#ffff" }} onClick={cerrarModal}>X</a></div>
                            </div>

                            <div id="profileIcon" class="profile-icon">👤</div>
                        </div>
                       
                                <form class="formulario-clinico">
                                    <div class="row">
                                        <label>Ficha No.: <input type="text" name="ficha_no"/></label>
                                        <label>Fecha: <input type="date" name="fecha"/></label>
                                    </div>
                                    
                                    <div class="row">
                                        <label>Cédula: <input type="text" name="cedula" onChange={handleChange} value={tabla.cedula} maxlength="11" required /></label>
                                        <label>Apellidos: <input type="text" name="apellidos" onChange={handleChange} value={tabla.apellidos} /></label>
                                        <label>Nombres: <input type="text" name="nombres" onChange={handleChange} value={tabla.nombres} /></label>
                                    </div>

                                    <div class="row">
                                        <label>Dirección: <input type="text" name="direccion" onChange={handleChange} value={tabla.direccion} /></label>
                                    </div>

                                    <div class="row">
                                        <label>Tel. Resid.: <input type="tel" name="telefono" onChange={handleChange} value={tabla.telefono} /></label>
                                        <label>Celular: <input type="tel" name="celular" onChange={handleChange} value={tabla.celular} /></label>
                                    </div>

                                    <div class="row">
                                        <label>Ocupación: <input type="text" name="ocupacion" onChange={handleChange} value={tabla.ocupacion} /></label>
                                        <label>Email: <input type="email" name="email" onChange={handleChange} value={tabla.email} /></label>
                                    </div>

                                    <div class="row">
                                        <label>Fecha Nacimiento: <input type="date" name="fechaNacimiento" onChange={handleChange} value={moment(tabla.fechaNacimiento).format("YYYY-MM-DD")} /></label>
                                        <label>Edad: <input type="number" name="edad" value={calcularEdad(tabla.fechaNacimiento,new Date)} /></label>
                                        <label>Sexo:
                                            <select name="sexo" onChange={handleChange} value={tabla.sexo}>
                                                <option value="">Seleccione</option>
                                                <option value="M">Masculino</option>
                                                <option value="F">Femenino</option>
                                            </select>
                                        </label>
                                        <label>Estado Civil: <input type="text" name="estadoCivil" onChange={handleChange} value={tabla.estadoCivil} /></label>
                                    </div>

                                    <div class="row">
                                        <label>Referido por: <input type="text" name="referidoPor" onChange={handleChange} value={tabla.referidoPor} /></label>
                                    </div>

                            <div class="pregunta-container">
                                <label>- ¿Ha sido hospitalizado en los últimos 2 años?</label>
                                <div class="opciones">
                                    <label><input type="radio" name="hospitalizado" value="si" /> Sí</label>
                                    <label><input type="radio" name="hospitalizado" value="no" /> No</label>
                                </div>
                            </div>

                            <div class="pregunta-container">
                                <label>¿Ha sido hospitalizado en los últimos 2 años?  </label>
                                    <div class="opciones">
                                        <label>  <input type="radio" name="opitalizado" onChange={handleChange} checked={tabla.opitalizado === 1} value={1} /> Sí</label>
                                        <label> <input type="radio" name="opitalizado" onChange={handleChange} checked={tabla.opitalizado === 0} value={0} /> No</label>
                                            </div>  
                                            
                                            </div>
                                            <label>Si su respuesta es Sí, explique:</label>
                            <textarea name="explicacion_hospitalizado" onChange={handleChange} value="X"></textarea>

                            <div class="pregunta-container">
                                <label>¿Está tomando algún medicamento? </label>
                                <div class="opciones">
                                    <input type="radio" name="tomaMedicamento" onChange={handleChange} checked={tabla.tomaMedicamento === 1} value={1} /> Sí
                                    <input type="radio" name="tomaMedicamento" onChange={handleChange} checked={tabla.tomaMedicamento === 0} value={0} /> No
                                                    </div>
                                                    </div>
                                                    <label>¿Cuál medicamento?</label>
                                    <input type="text" name="antecedentesMedicamentos" onChange={handleChange} value={tabla.antecedentesMedicamentos} />

                            <div class="pregunta-container">
                                <label>¿Es alérgico a algún medicamento? </label>
                                <div class="opciones">
                                    <input type="radio" name="es_Alergico" onChange={handleChange} checked={tabla.es_Alergico === 1} value={1} /> Sí
                                    <input type="radio" name="es_Alergico" onChange={handleChange} checked={tabla.es_Alergico === 0} value={0} /> No
                                                                   </div> 
                            </div> 
                            <div class="pregunta-container">
                                                                    <label> ¿Cuál?</label>
                                        <input type="text" name="alergicos" onChange={handleChange} value={tabla.alergicos} />
                                                                    </div>

                            <div class="pregunta-container">
                                <label>¿Ha tenido sangramiento anormal?  </label>
                                <div class="opciones">
                                    <input type="radio" name="ha_Cirugia" onChange={handleChange} checked={tabla.ha_Cirugia === 1} value={1} /> Sí
                                    <input type="radio" name="ha_Cirugia" onChange={handleChange} checked={tabla.ha_Cirugia === 0} value={0} /> No
                                                                            </div>
                                                                            </div>
                            <div class="pregunta-container">
                                <label>¿Ha recibido transfusiones sanguíneas? </label>
                                <div class="opciones">
                                    <input type="radio" name="transfusion" onChange={handleChange} checked={tabla.transfusion === 1} value={1} /> Sí
                                    <input type="radio" name="transfusion" onChange={handleChange} checked={tabla.transfusion === 0} value={0} /> No
                                                                                       
                                                                                    </div>
                                                                                    </div>

                            <div class="pregunta-container">
                                <label>¿Fuma? </label>
                                <div class="opciones">
                                    <input type="radio" name="fuma" onChange={handleChange} checked={tabla.fuma === 1} value={1} /> Sí
                                    <input type="radio" name="fuma" onChange={handleChange} checked={tabla.fuma === 0} value={0} /> No
                                                                                         </div>         
                                        <label>Cantidad por día: <input type="text" name="vece_Fuma" onChange={handleChange} value={tabla.vece_Fuma} /></label>
                                                                                         
                                                                                            </div>

                            <div class="pregunta-container">
                                <label>¿Ha tenido tratamiento con radiaciones o quimioterapia?</label>
                                    <div class="opciones">
                                    <input type="radio" name="radiaciones" onChange={handleChange} checked={tabla.radiaciones === 1} value={1} /> Sí
                                    <input type="radio" name="radiacion" onChange={handleChange} checked={tabla.radiaciones === 0} value={0} /> No
                                </div>
                                </div>
                                <div >
                                        <label>¿Por qué?: <input type="text" name="porque_Radiaciones" onChange={handleChange} value={tabla.porque_Radiaciones} /></label>
                                                                                                    </div>

                                                                                                    <label>Marque con una X si ha sufrido o sufre de alguna de estas condiciones:</label>
                            <div class="checkbox-group">
                                <table>
                                    <tr>
                                        <td> <label>Asma</label></td>
                                        <td> <input type="checkbox" name="asma" onChange={(e) => setTabla({ ...tabla, asma: e.target.checked ? 1 : 0, })} checked={tabla.asma === 1} /></td>
                                        <td><label>Diabetes</label></td>
                                        <td><input type="checkbox" name="diabetes" onChange={(e) => setTabla({ ...tabla, diabetes: e.target.checked ? 1 : 0, })} checked={tabla.diabetes === 1} /></td>
                                    </tr>
                                    <tr>
                                        <td> <label>Epilepsia</label></td>
                                        <td> <input type="checkbox" name="epilepsia" onChange={(e) => setTabla({ ...tabla, epilepsia: e.target.checked ? 1 : 0, })} checked={tabla.epilepsia === 1} /></td>
                                        <td><label>VIH</label></td>
                                        <td><input type="checkbox" name="vih" onChange={(e) => setTabla({ ...tabla, vih: e.target.checked ? 1 : 0, })} checked={tabla.vih === 1} /></td>
                                    </tr>
                                    <tr>
                                        <td>  <label>Artritis</label></td>
                                        <td> <input type="checkbox" name="epilepsia" onChange={(e) => setTabla({ ...tabla, epilepsia: e.target.checked ? 1 : 0, })} checked={tabla.epilepsia === 1} /></td>
                                        <td><label> Hepatitis</label></td>
                                        <td><input type="checkbox" name="hepatitis" onChange={(e) => setTabla({ ...tabla, hepatitis: e.target.checked ? 1 : 0, })} checked={tabla.hepatitis === 1} /></td>
                                    </tr>
                                    <tr>
                                        <td><label>Tuberculosis</label></td>
                                        <td><input type="checkbox" name="tuberculosis" onChange={(e) => setTabla({ ...tabla, tuberculosis: e.target.checked ? 1 : 0, })} checked={tabla.tuberculosis === 1} /> </td>
                                        <td> <label>Hipertensión</label></td>
                                        <td><input type="checkbox" name="hipertension" onChange={(e) => setTabla({ ...tabla, hipertension: e.target.checked ? 1 : 0, })} checked={tabla.hipertension === 1} /> </td>
                                    </tr>
                                    <tr>
                                        <td> <label>Úlceras Estomacales</label></td>
                                        <td><input type="checkbox" name="ulceras" onChange={(e) => setTabla({ ...tabla, ulceras: e.target.checked ? 1 : 0, })} checked={tabla.ulceras === 1} /> </td>
                                        <td> <label> Fiebre Reumática</label></td>
                                        <td><input type="checkbox" name="fiebre" onChange={(e) => setTabla({ ...tabla, fiebre: e.target.checked ? 1 : 0, })} checked={tabla.fiebre === 1} /></td>
                                    </tr>
                                    <tr>
                                        <td> <label>Ansiedad o Estrés</label></td>
                                        <td><input type="checkbox" name="ansiedad" onChange={(e) => setTabla({ ...tabla, ansiedad: e.target.checked ? 1 : 0, })} checked={tabla.ansiedad === 1} /> </td>
                                        <td> <label>Desórdenes Glandulares</label></td>
                                        <td><input type="checkbox" name="desorden" onChange={(e) => setTabla({ ...tabla, desorden: e.target.checked ? 1 : 0, })} checked={tabla.desorden === 1} /> </td>
                                    </tr>
                                    <tr>
                                        <td>  <label> Enfermedades Venéreas</label></td>
                                        <td><input type="checkbox" name="enfermedades_V" onChange={(e) => setTabla({ ...tabla, enfermedades_V: e.target.checked ? 1 : 0, })} checked={tabla.enfermedades_V === 1} /> </td>
                                        <td> <label>Enfermedades de la Sangre</label></td>
                                        <td><input type="checkbox" name="enfermedades_L" onChange={(e) => setTabla({ ...tabla, enfermedades_L: e.target.checked ? 1 : 0, })} checked={tabla.enfermedades_L === 1} /> </td>
                                    </tr>
                                    <tr>
                                        <td><label>Problemas Renales</label></td>
                                        <td><input type="checkbox" name="renales" onChange={(e) => setTabla({ ...tabla, renales: e.target.checked ? 1 : 0, })} checked={tabla.renales === 1} /> </td>
                                        <td> <label>Enfermedades Cardiacas</label></td>
                                        <td><input type="checkbox" name="enfermedades_C" onChange={(e) => setTabla({ ...tabla, enfermedades_C: e.target.checked ? 1 : 0, })} checked={tabla.enfermedades_C === 1} /> </td>
                                    </tr>
                                </table>

                               
                               
                                
                                
                                
                                                                                                    </div>

                                                                                                    <label>Si padeció alguna de las enfermedades anteriores, especifique cuál:</label>
                                    <input type="text" name="antecedentesMedicos" onChange={handleChange} value={tabla.antecedentesMedicos} />

                                                                                                        <label>Indique otra enfermedad, condición o problema:</label>
                                                                                                        <input type="text" name="condicion_extra"/>

                            <div class="pregunta-container">
                                                                                                                <label>¿Ha notado algún cambio en su estado de salud últimamente?  </label>
                                <div class="opciones">
                                    <input type="radio" name="cambio_salud" onChange={handleChange} checked={tabla.cambio_Salud === 1} value={1} /> Sí
                                    <input type="radio" name="cambio_salud" onChange={handleChange} checked={tabla.cambio_Salud === 0} value={0} /> No
                                </div> 
                                                                                                                    </div>

                                                                                                                    <label>¿Ha tenido algún problema asociado a tratamiento dental?</label>
                            <input type="text" name="problema_dental" onChange={handleChange} value={tabla.nombreTratamiento} />

                                                                                                                        <h3>SOLO PARA CONTESTAR SI ES DEL SEXO FEMENINO:</h3>
                            <div class="pregunta-container">
                                <label>¿Está embarazada?  </label>
                                <div class="opciones">
                                    <input type="radio" name="embarazada" onChange={handleChange} checked={tabla.embarazada === 1} value={1} /> Sí
                                    <input type="radio" name="embarazada" onChange={handleChange} checked={tabla.embarazada === 0} value={0} /> No
                                </div> 
                                                                                                                                </div>

                                                                                                                                <label>¿Tiene problemas asociados al período menstrual?</label>
                            <input type="text" name="problemas_menstruacion" onChange={handleChange}/>

                                                                                                                                    <label>Observaciones:</label>
                            <textarea name="observaciones" onChange={handleChange} value={tabla.observaciones} ></textarea>
                                                                                                                                </form>
                            </div>
                            <div class="btn-group">
                                <button type="button" onClick={cerrarModal} class="btn btn-danger">Cerrar</button>
                                <button type="button" class="btn btn-primary" onClick={guardarCambios}>Guardar</button>
                            </div>
                       {/* </form>
                    </div>*/}
                </ModalBody>
                <ModalFooter>

                </ModalFooter>
            </Modal>

         


            <Modal isOpen={Receta} className="modal-preguntas">
                <ModalHeader className="modal-header1">
                    <div class="box">
                        <div>   Receta a Nombre de: {paciente.nombres + " " + paciente.apellidos}</div>
                        <div><a className="btn" style={{ color: "#ffff" }} onClick={() => TerminarReceta(0)}>X</a></div>
                    </div>

                </ModalHeader>
                <ModalBody>
                    <div >
                        <Row>
                            <Col md="3">  <FormGroup>

                                <Label>* Medicamento</Label>
                                <Input onChange={(e) =>handleChange3(e.target)}></Input>
                                <Select
                                    name={"medicamentoID"}
                                    onChange={handleChange2}
                                    value={options.filter(x => x.value == tablaReceta.medicamentoID).map(x => x)}
                                    options={options}
                                /></FormGroup></Col>


                            <Col md="2">  <FormGroup > <Label for="exampleEmail">Dosificacion</Label>
                                <Input type="text" name="dosificacion" value={tablaReceta.dosificacion} id="comentario"
                                    placeholder="dosificacion" onChange={handleChangeReceta} />

                            </FormGroup>  </Col>
                            <Col md="4">  <FormGroup > <Label for="exampleEmail">Comentario</Label>
                                <Input type="text" name="comentario" value={tablaReceta.comentario} id="comentario"
                                    placeholder="Comentario" onChange={handleChangeReceta} />

                            </FormGroup>  </Col>
                            <Col md="2">
                                <Button size="sm" color="primary"
                                    onClick={guardarCambiosReceta}
                                >Agregar</Button></Col>

                        </Row>
                        <table>
                            <tr>
                                <th>Medicamento</th>
                                <th>Dosificacion</th>
                                <th>Comentario</th>
                                <th>Quitar</th>
                            </tr>
                            {ListadoReceta.map(x => (
                                <tr>
                                    <td>{x.nombreMedicamento}</td>
                                    <td>{x.dosificacion}</td>
                                    <td>{x.comentario}</td>
                                    <td> <Button size="sm" color="danger"
                                        onClick={() => EliminarReceta(x.codigoUnico)}
                                    >X</Button></td>
                                </tr>
                            ))}
                        </table>

                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="success" size="sx" target="_blank"
                        onClick={() => TerminarReceta(tablaRecord.codigoUnico)}
                    ><i className="fa fa-print"></i></Button>
                    <Button size="sm" color="danger"
                        onClick={() => TerminarReceta(0)}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>


            {/*////Recibo*/}
            <Modal isOpen={verModalImpresion} className="modal-preguntas">
                <ModalHeader className=" modal-header1">
                    Historia clinica de : {tablaHistoria.nombrePaciente}
                </ModalHeader>
                <ModalBody>
                    <div>

                        <Row>

                            <Col md={4}>
                                <FormGroup>
                                    <Label for="Historia Enfermedad Actual">Historia Enfermedad Actual</Label>
                                    <textarea name="historiaEnfermedadActual"
                                        onChange={handleChangeHistoria} value={tablaHistoria.historiaEnfermedadActual} ></textarea>
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup>
                                    <Label for="Historia Enfermedad Actual">Tiempo Evoluccion</Label>
                                    <textarea name="tiempoEvoluccion" value={tablaHistoria.tiempoEvoluccion}
                                        onChange={handleChangeHistoria}></textarea>
                                </FormGroup>
                            </Col>

                            <Col md={4}>
                                <FormGroup>
                                    <Label for="Historia Enfermedad Actual">Antecedente Patologico Personales</Label>
                                    <textarea name="antecedentePatologicoPersonales" value={tablaHistoria.antecedentePatologicoPersonales}
                                        onChange={handleChangeHistoria}></textarea>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={4}>
                                <FormGroup>
                                    <Label for="Historia Enfermedad Actual">Estudios Realizado</Label>
                                    <textarea name="estudiosRealizado" value={tablaHistoria.estudiosRealizado}
                                        onChange={handleChangeHistoria}></textarea>
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup>
                                    <Label for="Historia Enfermedad Actual">Tratamiento Previos</Label>
                                    <textarea name="tratamientoPrevios" value={tablaHistoria.tratamientoPrevios}
                                        onChange={handleChangeHistoria}></textarea>
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup>
                                    <Label for="Historia Enfermedad Actual">Procedimiento Solicitado</Label>
                                    <textarea name="procedimientoSolicitado" value={tablaHistoria.procedimientoSolicitado}
                                        onChange={handleChangeHistoria}></textarea>
                                </FormGroup>
                            </Col>


                        </Row>
                        <div style={{ textAlign: "right" }}>
                            <Button color="secondary" onClick={() => imprimirRecibo()}>Imprimir Recibo</Button>
                            {(tablaHistoria.historiID != 0) ? (<Button color="success" onClick={() => setTablaHistoria(modeloHistoriaClinica)}>Nuevo</Button>) : (<Button color="success" onClick={() => GuardarHistoriaGastro()}>GUARDAR</Button>)}

                        </div>

                        <wbr />




                    </div>
                    <div>
                        <h5>Historias anteriores</h5>
                        <table className="tabla min-w-full">
                            <tr>
                                <th>Fecha</th>
                                <th>Precedimiento solicitado</th>
                                <th>Imprimir</th>
                            </tr>
                            {(ListadoHistoria.length < 1) ? ("No hay registros anteriores") : (
                                ListadoHistoria.filter(t => t.tipoReporte == 2).map(x => (<tr>
                                    <td> {moment(x.fecha).format("DD/MM/YYYY")}</td>
                                    <td> {x.procedimientoSolicitado}</td>
                                    <td>   <Button color="secondary" onClick={() => RimprimirRecibo(x)}>Ver Historia</Button></td>
                                </tr>
                                )))}
                        </table>

                    </div>
                    <div id="reciboPago" className="mt-4 p-3" hidden>

                        <div class="container" style={{color:"#000"} } >



                            <div class="title">HISTORIA CLÍNICA</div>


                            <div class="info-section">
                                <span class="label">FECHA: </span>
                                <span class="lineH">{moment(tablaHistoria.fecha).format("DD/MM/YYYY")}</span>
                            </div>
                            <div class="info-section">
                                <span class="label">NOMBRE DEL PACIENTE:</span>
                                <span class="lineH"> {tablaHistoria.nombrePaciente}</span>
                            </div>
                            <div class="info-section">
                                <span class="label">EDAD:</span>
                                <span class="lineH">{tablaHistoria.edad}</span>
                            </div>
                            <div class="info-section">
                                <span class="label">SEGURO: </span>
                                <span class="lineH">{tablaHistoria.nombreSeguro}</span>
                            </div>


                            <div class="block-title">HISTORIA DE LA ENFERMEDAD ACTUAL</div>
                            <ul class="bullet-list">
                                <li><span class="bullet-line">{tablaHistoria.historiaEnfermedadActual}</span></li>

                            </ul>

                            <div class="block-title">TIEMPO DE EVOLUCIÓN</div>
                            <ul class="bullet-list">
                                <li><span class="bullet-line">{tablaHistoria.tiempoEvoluccion}</span></li>
                            </ul>

                            <div class="block-title">ANTECEDENTES PATOLÓGICOS PERSONALES</div>
                            <ul class="bullet-list">
                                <li><span class="bullet-line">{tablaHistoria.antecedentePatologicoPersonales}</span></li>
                            </ul>

                            <div class="block-title">ESTUDIOS REALIZADOS</div>
                            <ul class="bullet-list">
                                <li><span class="bullet-line">{tablaHistoria.estudiosRealizado}</span></li>

                            </ul>

                            <div class="block-title">TRATAMIENTOS PREVIOS</div>
                            <ul class="bullet-list">
                                <li><span class="bullet-line">{tablaHistoria.tratamientoPrevios}</span></li>
                            </ul>

                            <div class="block-title">PROCEDIMIENTO SOLICITADO</div>
                            <ul class="bullet-list">
                                <li><span class="bullet-line">{tablaHistoria.procedimientoSolicitado}</span></li>

                            </ul>

                            <br></br>
                            <div class="signature">
                                {/*<div class="name">ANA YDALINA PICHARDO NÚÑEZ</div>*/}
                                <div class="name">{Empresa.descripcion}</div>
                                <div class="specialty">{Empresa.tokenWhatsapp}</div>
                                {/*<div class="specialty">MÉDICO GASTROENTERÓLOGO-ENDOSCOPISTA</div>*/}
                            </div>
                        </div>
                    </div>


                </ModalBody>
                <ModalFooter>

                    <Button size="sm" color="danger"
                        onClick={cerrarModal}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>


            {/*////Recibo examinado*/}
            <Modal isOpen={verModalImpresion1} className="modal-preguntas">
                <ModalHeader className=" modal-header1">
                    Historia clinica de : {tablaHistoria.nombrePaciente}
                </ModalHeader>
                <ModalBody>
                    <div>

                        <Row>

                            <Col md={6}>
                                <FormGroup>
                                    <Label for="Historia Enfermedad Actual">Constatado</Label>
                                    <textarea name="constatado"
                                        onChange={handleChangeHistoria} value={tablaHistoria.constatado} ></textarea>
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="Historia Enfermedad Actual">Recomendado</Label>
                                    <textarea name="recomendado" value={tablaHistoria.recomendado}
                                        onChange={handleChangeHistoria}></textarea>
                                </FormGroup>
                            </Col>


                        </Row>


                        <div style={{ textAlign: "right" }}>
                            <Button color="secondary" onClick={() => imprimirRecibo1()}>Imprimir Recibo</Button>
                            {(tablaHistoria.historiID != 0) ? (<Button color="success" onClick={() => setTablaHistoria(modeloHistoriaClinica)}>Nuevo</Button>) : (<Button color="success" onClick={() => GuardarHistoriaGastro()}>GUARDAR</Button>)}

                        </div>

                        <wbr />




                    </div>
                    <div>
                        <h5>Historias anteriores</h5>
                        <table className="tabla min-w-full">
                            <tr>
                                <th>Fecha</th>
                                <th>Precedimiento solicitado</th>
                                <th>Imprimir</th>
                            </tr>
                            {(ListadoHistoria.length < 1) ? ("No hay registros anteriores") : (
                                ListadoHistoria.filter(t => t.tipoReporte == 2).map(x => (<tr>
                                    <td> {moment(x.fecha).format("DD/MM/YYYY")}</td>
                                    <td> {x.procedimientoSolicitado}</td>
                                    <td>   <Button color="secondary" onClick={() => RimprimirRecibo(x)}>Ver Historia</Button></td>
                                </tr>
                                )))}
                        </table>

                    </div>
                    <div id="reciboPago1" hidden className="mt-4 p-3" >

                        <div class="certificate bodycert">

                            <div class="headercert">
                                <div class="gold-curve"></div>
                            </div>


                            <div class="doctor-name">
                                <h1>{Empresa.descripcion}</h1>
                                <div class="gold-line"></div>
                            </div>


                            <div class="specialties">

                                {Empresa.tokenWhatsapp}
                                {/*<p>Medicina Interna · Gastroenterología</p>*/}
                                {/*<p>Endoscopía Digestiva · Nutrición Clínica</p>*/}
                            </div>


                            <div class="contact-info">
                                <p>{Empresa.direccion} Tels.: {Empresa.telefono} </p>
                                    {/*Clínica Dr. Rodríguez Santos: Calle Bartolomé Colón, No. 20 • Tels.: 809-333-6671 Ext. 649</p> daly008@hotmail.com*/}
                                <p>Directo: {Empresa.noWhatsapp} • Celular: 829-343-6584 • E-mail:{Empresa.correo }</p>
                            </div>


                            <div class="form-container">
                                <p>
                                    <span class="bold">Yo </span>
                                    <span class="bold italic">{Empresa.descripcion}</span><span>,</span>
                                    <span> Médico provisto del correspondiente exequátur No. </span>
                                    <span class="bold">{Empresa.plantillaWhatsapp }</span> de cédula de Identidad y Electoral No.  <span class="bold">{Empresa.rnc}</span>{/*05500318414*/}
                                </p>
{/*71204*/}
                                <p class="bold">CERTIFICO haber examinado a:</p>
                                <div class="linecert"> {tablaHistoria.nombrePaciente}</div>

                                <p>Cédula de Identidad y Electoral No. <b>{tabla.cedula}</b></p>

                                <p>y constatado:</p>
                                <div class="linecert">{tablaHistoria.constatado}</div>


                                <p class="bold">Por lo que recomiendo</p>
                                <div class="linecert">{tablaHistoria.recomendado}</div>



                                <div style={{height:"100px"} }></div>

                                <p>Expido la presente Certificación en Santo Domingo a petición del interesado.</p>

                                <p>Hoy día <b>{moment(new Date()).format("DD")}</b> del mes de <b>{moment(new Date()).format("MMMM")}</b> del año <b>{moment(new Date()).format("YYYY")}</b> </p>

                                <div class="signature-line"></div>
                                <p class="signature-text"><b>Firma del Médico y Sello</b></p>
                            </div>

                            <div class="footer">
                                <p></p>
                            </div>
                        </div>
                    </div>


                </ModalBody>
                <ModalFooter>

                    <Button size="sm" color="danger"
                        onClick={cerrarModal}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>

            {/*Dientes*/}

            <Modal isOpen={VerDientes} className="modal-preguntas">
                <ModalHeader className="modal-header1">
                    <div class="box">
                        <div>   Dientes: {paciente.nombres + " " + paciente.apellidos}</div>
                        <div><a className="btn" style={{ color: "#ffff" }} onClick={() => setVerDientes(false)}>X</a></div>
                    </div>

                </ModalHeader>
                <ModalBody>

                    Diente: {tablaD.noDiente} Cara: {tablaD.caraDiente}

                    <Row>

                        <Col md={6}>
                            <FormGroup>
                                <Label for="Historia Enfermedad Actual">Proceso</Label>
                                <textarea name="historia"
                                    onChange={handleChangeDiente} value={tablaD.historia} ></textarea>
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup>
                                <Label for="Historia Enfermedad Actual">Comentario</Label>
                                <textarea name="comentario" value={tablaD.comentario}
                                    onChange={handleChangeDiente}></textarea>
                            </FormGroup>
                        </Col>


                    </Row>

              
                   

                </ModalBody>
                <ModalFooter>

                    <Button size="sm" color="success"
                        onClick={() => GuardarDiente()}
                    >Guardar</Button>

                    <Button size="sm" color="danger"
                        onClick={() => setVerDientes(false)}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>


            {/*Embarazada*/}

            <Modal isOpen={Verrecord} className="modal-preguntas">
                <ModalHeader className="modal-header1">
                    <div class="box">
                        <div>   Embarazada: {paciente.nombres + " " + paciente.apellidos}</div>
                        <div><a className="btn" style={{ color: "#ffff" }} onClick={() => cerrarModalR()}>X</a></div>
                    </div>

                </ModalHeader>
                <ModalBody>
                    <div>
                        <Row>
                            <div class="col-md-6">
                                <h4 class="mb-4"><b>Consulta</b></h4>

                                <form>


                                    <div class="mb-3">
                                        <label for="historiaClinica" class="form-label">Historia Clínica</label>
                                        <textarea class="form-control" id="historiaClinica" name="historiaClinica" rows="3"
                                            value={tablaRecord.historiaClinica}></textarea>
                                    </div>

                                    <div class="mb-3">
                                        <label for="comentario" class="form-label">Comentario</label>
                                        <textarea class="form-control" id="comentario" name="comentario" rows="3"
                                            value={tablaRecord.comentario}></textarea>
                                    </div>


                                </form>
                            </div>

                            {/*Segunda Seccion*/}
                            <div class="col-md-6" >
                                <h4 class="mb-4"><b>Medicamento Receta</b></h4>
                                <table>
                                    <tr>
                                        <th>Medicamento</th>
                                        <th>Dosificacion</th>
                                        <th>Comentario</th>
                                    </tr>
                                    {ListadoReceta.map(x => (
                                        <tr>
                                            <td>{x.nombreMedicamento}</td>
                                            <td>{x.dosificacion}</td>
                                            <td>{x.comentario}</td>

                                        </tr>
                                    ))}
                                </table>
                            </div>
                        </Row>
                    </div>
                </ModalBody>
                <ModalFooter>

                    <Button size="sm" color="danger"
                        onClick={() => cerrarModalR()}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>





            <Modal isOpen={VerEvaluacionPre} className="modal-preguntas">
                <ModalHeader className="modal-header1" toggert={cerrarModalR} >
                    EVALUACION QUIRURGICA

                </ModalHeader>
                <ModalBody>
                    <div class="patient-info">
                        <p><span class="label" style={{ textDecoration: "underline" }}>NOMBRE:</span> {tablaHistoria.nombrePaciente}</p>
                        <p><span class="label" style={{ textDecoration: "underline" }}>EDAD:</span> {tablaHistoria.edad} AÑOS</p>
                        <p><span class="label" style={{ textDecoration: "underline" }}>MOTIVO:</span> <Input onChange={(e) => setEvaluacionM(e.target.value)}
                            value={EvaluacionM}
                        ></Input></p>
                    </div>

                    <div> <label class="form-label">EVALUACIÓN PRE-QUIRÚRGICA</label>
                        <Input type="textarea" rows={5}
                            onChange={(e) => setEvaluacionQ(e.target.value)}
                            value={EvaluacionQ}
                        ></Input>
                    </div>
                    <br></br>

                    <div> <label class="form-label">RECOMENDACIONES:</label>
                        <Input type="textarea" rows={5}
                            onChange={(e) => setEvaluacionR(e.target.value)}
                            value={EvaluacionR}
                        ></Input>
                    </div>


                    <Button size="sm" color="success"
                        onClick={() => imprimirRecibo2()}
                    >Imprimir</Button>

                    <div id="reciboPago2" hidden className="mt-4 p-3" style={{ color: "#000 !important" }} >
                        {/*<!-- Header with logo and title -->*/}
                        <div class="header" style={{ background: "none" }}>

                            <img class="logo" style={{ width: "80px", height: "74px" }} src="http://pichardo.systemapatech.com/imagen/LogoPichardoCirugia.jpg" alt="Logo Médico" />
                            <div class="title">
                                <h2 style={{ textDecoration: "underline" }}>{Empresa.descripcion}</h2>
                                <h2 style={{ textDecoration: "underline" }}>{Empresa.tokenWhatsapp}</h2>
                                {/*<h2 style={{ textDecoration: "underline" }}>MEDICINA INTERNA-GASTROENTEROLOGÍA</h2>*/}
                            </div>
                        </div>
                        <br></br>
                        {/*<!-- Patient Information -->*/}
                        <div class="patient-info">
                            <p><span class="label" style={{ textDecoration: "underline" }}>NOMBRE:</span> {tablaHistoria.nombrePaciente}</p>
                            <p><span class="label" style={{ textDecoration: "underline" }}>EDAD:</span> {tablaHistoria.edad} AÑOS</p>
                            <p><span class="label" style={{ textDecoration: "underline" }}>MOTIVO:</span> {EvaluacionM}</p>
                        </div>
                        <br></br>
                        {/* <!-- Evaluation Section -->*/}
                        <h3 class="evaluation-title" style={{ textDecoration: "underline" }}>EVALUACIÓN PRE-QUIRÚRGICA</h3>

                        <div class="evaluation-content">
                            <p style={{ whiteSpace: 'pre-line' }}>{EvaluacionQ}</p>
                        </div>
                        <br></br>
                        {/* <!-- Recommendations -->*/}
                        <div class="recommendations">
                            <h3 style={{ textDecoration: "underline" }}>RECOMENDACIONES:</h3>
                            <ul>
                                <p style={{ whiteSpace: 'pre-line' }}>{EvaluacionR}</p>
                            </ul>
                        </div>
                        <br></br>
                        <br></br>
                        <br></br>
                        {/*  <!-- Footer -->*/}
                        <div class="footer">
                            <p style={{ textDecoration: "underline" }}>{Empresa.descripcion}</p>
                            <p>{Empresa.tokenWhatsapp}</p>{/*<p>GASTROENTERÓLOGO</p>*/}
                            <p>EXC {Empresa.plantillaWhatsapp }</p>{/*17421*/}
                        </div>

                    </div>



                </ModalBody>
                <ModalFooter>

                    <Button size="sm" color="danger"
                        onClick={() => cerrarModalR()}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>

            {/*RECETA}*/}

            <div>

                <div div id="reciboPago3" hidden className="mt-4 p-3" >
                    
                    
                    <div class="hoja-timbrada">
                            <div class="MediapaginaHorizontal">
                        <div class="headerR" style={{background:"none"} }>
                            <img src="http://pichardo.systemapatech.com/imagen/mallaizquierda.webp" alt="Logo Izquierdo" class="logo-left"/>
                            <img src="http://pichardo.systemapatech.com/imagen/malladerecha.webp" alt="Logo Derecho" class="logo-right"/>
                            <img src="http://pichardo.systemapatech.com/imagen/logogastro.webp" alt="Logo Central" class="logo-center" style={{ width: "200px" }} />
                                <h1 style={{ marginTop: "-60px" }} >{Empresa.descripcion}</h1>
                                              
                                <p class="subtitle">{Empresa.tokenWhatsapp}</p>
                                                {/*<p class="subtitle">Medicina Interna | Gastroenterología | Endoscopia Digestiva | Balón Gástrico</p>*/}
                         {NombreReceta }
                                <p class="subtitle">Exequátur No.{Empresa.plantillaWhatsapp } </p>{/*71204*/}
                            <img src="http://pichardo.systemapatech.com/imagen/rxreceta.webp" alt="RX Logo" class="rx-logo"/>
                                                </div>

                                                <div>
                            <table class="table" id="facturas-table" style={{ marginTop: "100px", fontSize: "20px", textTransform: "uppercase"} }>
                                                        <thead>
                                                            <tr>
                                                                <th></th>
                                                                <th></th>
                                                                <th></th>
                                                                <th></th>
                                                                <th></th>
                                                            </tr>
                                                        </thead>
                                {ListadoReceta.map(x => (
                                    <tr>
                                        <td style={{ padding: "30px" } }>{x.nombreMedicamento}</td>
                                        <td style={{ padding: "30px" }}>{x.dosificacion}</td>
                                        <td style={{ padding: "30px" }}>{x.comentario}</td>
                                       
                                    </tr>
                                ))}
                                                    </table>

                                                </div>

                        <img src="http://pichardo.systemapatech.com/imagen/fondogastro.webp" alt="Background Image" class="background-image"/>

                                                    <div class="patient-info">
                                                        <div class="info-line">
                                <span>Nombre del Paciente:</span>
                                <b style={{ position: "absolute", marginLeft: "22%" }} >{(pacientenombres === "") ? pacientenombres : paciente.nombres + " " + paciente.apellidos}</b>
                                                        </div>
                                                        <div class="info-line">
                                                            <span>Firma:</span>
                                                        </div>
                                                        <div class="info-line">
                                                            <span>Fecha:</span>
                                                        </div>
                                                    </div>

                                                    <div class="footer">
                                                        <div class="footer-contact">
                                                            <div>
                                                                <img src="/imagen/ubicacion.png" alt="Ubicación" class="footer-icons"/>
                                        {Empresa.direccion}    {/*Clínica Dr. Rodríguez Santos: Calle Bartolomé Colón, No. 20, Villa Consuelo, D.N.*/}
                                                            </div>
                                                            <div>
                                                                <img src="/imagen/telefono.png" alt="Teléfono" class="footer-icons"/>
                                        {Empresa.telefono}
                                    <img src="/imagen/whatsapp.png" alt="Móvil" class="footer-icons" style={{ marginLeft: "1rem" }} />
                                        {Empresa.noWhatsapp}    {/*829-343-6584*/}
                                                                    </div>
                                                                    <div>
                                                                        <img src="/imagen/arroba.png" alt="Email" class="footer-icons"/>
                                        {Empresa.correo}   {/*daly008@hotmail.com*/}
                                                                    </div>
                                                            </div>
                                                            <div class="social-media">
                                                                <p>Síguenos:</p>
                                                                <img src="/imagen/Facebooklogo.svg" alt="Facebook" class="footer-icons"/>
                                                                    <img src="/imagen/Instagramlogo.png" alt="Instagram" class="footer-icons"/>
                                                                        <span>@draydalinapichardo</span>
                                                                    </div>
                                                            </div>
                                                        </div>

                    </div>
                                                 </div>
            </div>
          
        </>
    )

}
export default Odontologia;